<template>
  <nav
    :class="classes"
    class="navbar navbar-expand-lg"
  >
    <div class="container-fluid">
      <slot />

      <transition name="slide-fade">
        <suspense>
          <div
            v-show="showNavbar"
            id="navigation"
            class="collapse navbar-collapse justify-content-end show"
            :class="navbarMenuClasses"
          >
            <ul class="navbar-nav">
              <slot name="navbar-menu" />
            </ul>
          </div>
        </suspense>
      </transition>
    </div>
  </nav>
</template>

<script lang="ts">
import { computed } from 'vue';

export default {
  name: 'Navbar',
  props: {
    showNavbar: {
      type: Boolean,
      default: false,
      description: 'Whether navbar is visible',
    },
    navbarMenuClasses: {
      type: [String, Object],
      default: '',
      description: 'Navbar menu css classes',
    },
    transparent: {
      type: Boolean,
      default: true,
      description: 'Whether navbar is transparent',
    },
    position: {
      type: String,
      default: 'absolute',
      description: 'Navbar position (absolute|fixed|relative)',
    },
    type: {
      type: String,
      default: 'white',
      validator(value: string) {
        return ['white', 'default', 'primary', 'danger', 'success', 'warning', 'info'].includes(value);
      },
      description: 'Navbar type (primary|info|danger|default|warning|success)',
    },
  },
  setup: (props: any) => {
    const classes = computed(() => {
      const color = `bg-${props.type}`;
      const navPosition = `navbar-${props.position}`;

      return {
        'navbar-transparent': !props.showNavbar && props.transparent,
        [color]: props.showNavbar || !props.transparent,
        [navPosition]: true,
      };
    });

    return { classes };
  },
};
</script>

<style scoped>
.navbar-relative {
  position: relative;
}
@media screen and (max-width: 991px) {
  .navbar .container-fluid {
    padding: 0;
  }
}
</style>
